@if (mapLoaded && !sessionExpired) {
  <div class="whole-app">
    <app-loader></app-loader>
    <router-outlet></router-outlet>
  </div>
}

@if (sessionExpired) {
  <div class="session-expired">
    <app-svg-icon name="session-expired" [cssClass]="'session-expired__icon'" />
    <div class="session-expired__label">
      <h4>{{ 'views.sessionExpired.yourSessionHasExpiredDueToInactivity' | translate }}</h4>
      <p>{{ 'views.sessionExpired.pleaseReloadTheAppToRestoreYourSession' | translate }}</p>
    </div>
    <div class="session-expired__actions">
      <button mat-flat-button color="primary" (click)="onReload()">
        {{ 'buttons.sessionExpiredReload' | translate }}
      </button>
    </div>
  </div>
}
<app-svg-holder></app-svg-holder>
